module.exports = __webpack_public_path__ + "static/media/px.b41802a3.hdr";